import styled from 'styled-components'

import { colors } from '../../styles/colors'

interface IconProps {
  size?: number
}
export const Icon = styled.img<IconProps>`
  src: ${props => props.src};
  color: ${colors.white};
  width: ${props => `${props.size}px` ?? '16px'};
  height: ${props => `${props.size}px` ?? '16px'};
  margin-right: 5px;
`
